module.exports = __webpack_public_path__ + "static/assets/7596fe1f3c3a043a6e41a1aa6645e1b3.png";